export default __webpack_public_path__ + "static/media/mosaic-new-1.35fc22c1.png";